<template>
  <div class="exp-run-page">
    <div class="exp-run-title">
      <div class="title-info">
        <div class="title-back" @click="$router.back(-1)">
          <i class="el-icon-back"></i>
          返回
        </div>
      </div>
    </div>
    <div class="exp-run-main" ref="main">
      <div class="main-left" :class="{'left-full': !isRemote }">
        <div class="left-tabs">
          <span :class="{'active': type == 'doc'}" @click="type = 'doc'">实验文档</span>
          <span :class="{'active': type == 'report'}" @click="type = 'report'">实验报告</span>
          <img class="full-img" src="~@/assets/imgs/ic_full_screen_document.png"/>
        </div>
        <keep-alive>
          <component :is="typeComp[type]" :uid="uid" :isSave="isSave"/>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import expRunDoc from './components/exp-run-doc'
import expRunReport from './components/exp-run-report'

export default {
  data() {
    return {
      uid: '', // 竞赛实验项目记录uid
      isRemote: false, // 是不是远程
      typeComp: {
        'doc': 'expRunDoc',
        'report': 'expRunReport'
      },
      type: 'report',
      isSave: false // 是否保存实验报告
    }
  },
  components: {
    expRunDoc,
    expRunReport
  },
  methods: {
    init() {
      this.uid = this.$route.params.uid
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import "~@/assets/css/exp-runing";
</style>
